import { z } from 'zod';

export const roleSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  description: z.string().nullable(),
  userTypeId: z.coerce.number().nullable(),
  userTypeName: z.string().nullable(),
  isActive: z.boolean(),
  assignedUserCount: z.coerce.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const roleListSchema = z.array(roleSchema);

export type Role = z.infer<typeof roleSchema>;

export const ROLE_NAME_MAX_LENGTH = 100;
export const ROLE_DESCRIPTION_MAX_LENGTH = 500;

export const roleFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(ROLE_NAME_MAX_LENGTH, `Name must be ${ROLE_NAME_MAX_LENGTH} characters or fewer`),
  description: z
    .string()
    .trim()
    .max(
      ROLE_DESCRIPTION_MAX_LENGTH,
      `Details must be ${ROLE_DESCRIPTION_MAX_LENGTH} characters or fewer`,
    ),
  userTypeId: z.number().int().positive().optional(),
  isActive: z.boolean(),
});

export type RoleFormValues = z.infer<typeof roleFormSchema>;

export interface CreateRolePayload {
  name: string;
  description?: string;
  userTypeId?: number;
  isActive?: boolean;
}

export type UpdateRolePayload = Partial<CreateRolePayload>;
